:host(.pds-sortable-item) {
  align-items: center;
  display: flex;
  padding-block: var(--pine-dimension-xs);
  padding-inline: var(--pine-dimension-md);

  .pds-sortable-item__actions {
    margin-inline-start: auto;
    padding-inline-start: var(--pine-dimension-md);
  }

  .pds-sortable-item__handle {
    line-height: 1;
    margin-inline-end: var(--pine-dimension-md);
  }

  // styles when sortable is bordered
  .pds-sortable--bordered & {
    &:first-child {
      border-start-end-radius: calc(var(--pine-dimension-xs) * 1.25);
      border-start-start-radius: calc(var(--pine-dimension-xs) * 1.25);
    }

    &:last-child {
      border-end-end-radius: calc(var(--pine-dimension-xs) * 1.25);
      border-end-start-radius: calc(var(--pine-dimension-xs) * 1.25);
    }
  }

  // styles when sortable is divided
  .pds-sortable--divided & {
    border-block-end: var(--pine-border);

    &:last-child {
      border-block-end: 0;
    }
  }

  // cursor styles based on handle-type
  .pds-sortable--handle-type-row & {
    cursor: grab;
  }

  .pds-sortable--handle-type-handle & {
    .pds-sortable-item__handle {
      cursor: grab;
    }
  }

  // styles when sortable is disabled
  .pds-sortable--disabled & {
    cursor: not-allowed;
    opacity: 0.5;

    .pds-sortable-item__handle {
      cursor: not-allowed;
    }
  }
}

:host(.pds-sortable-item):hover {
  .pds-sortable--disabled & {
    background-color: transparent;
  }

  .pds-sortable:not(.pds-sortable--disabled) & {
    background-color: var(--pine-color-background-container-hover);

    pds-icon {
      color: var(--pine-color-info)
    }
  }
}

:host(.pds-sortable-item--drag) {
  background-color: var(--pine-color-background-container);
  border-radius: 0;
  box-shadow: var(--pine-box-shadow-400);
  opacity: 1;
}

:host(.pds-sortable-item--ghost) {
  background-color: var(--pine-color-background-container-hover);
  border-radius: 0;
}
